<!-- =========================================================================================
  File Name: transactionSuccessful.vue
  Description: Display success message and update transaction statuse to Pending
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 21072020
========================================================================================== -->
<template>
  <div id="page-deposit-create">
    <vx-card >
      <div class="vx-row w-full">
        <h3>{{message}}</h3>    
      </div>
    </vx-card>
  </div>
</template>

<script>
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
export default {
  data () {
    return {
      transactionId: -1,
      message: ''
    }
  },
  methods: {
    processSuccessful () {
      this.message = `Successful transaction: ${  this.transactionId}`

      this.$store.dispatch('TransactionMng/setTransactionSuccessfulState', this.transactionId)
        .then(res => { 
          console.info(res.data)
        })
    }
  },
  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    this.transactionId = this.$route.params.id
    this.processSuccessful()
  }
}
</script>